<template>
  <footer class="footer">

    <div class="back-top">
      <i class="iconfont icon-arrow" @click="backTop"></i>
    </div>

    <div class="wrap">
      <div class="social">
        <a class="item" :href="options.facebook" target="_blank">
          <i class="iconfont" :class="`icon-facebook`"></i>
        </a>
        <a class="item" :href="options.instagram" target="_blank">
          <i class="iconfont" :class="`icon-instagram`"></i>
        </a>
        <template v-for="(item,i) in socialList">
          <i :key="i" class="iconfont item" :class="`icon-${item.name}`" @click="toggleContent(item.name)"></i>
        </template>
      </div>
      <div class="spacer"></div>
      <div class="icp"><a href="https://beian.miit.gov.cn/" target="_blank">{{options.ipc}}</a></div>
      <div class="spacer"></div>
      <div class="copyright">Copyright2018 © SHAPE OF SHAPES</div>
    </div>
    <div class="item-detail" :class="{'show': showType !== ''}">
      <div class="line"></div>
      <div class="content">
        <template v-if="showType === 'wechat'">
          <img class="wechat" :src="`${options.cdn}/${options.wechat}`">
        </template>
        <template v-if="showType === 'mail'">
          <a :href="`mailto:${options.mail}`">{{options.mail}}</a>
        </template>
        <template v-if="showType === 'address'">
          <div v-html="options.address"></div>
        </template>
      </div>
    </div>
  </footer>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: "mew-footer",
    data () {
      return {
        socialList: [
          {name: 'wechat', type: 'html'},
          {name: 'mail', type: 'html'},
          {name: 'address', type: 'html'}
        ],
        showType: ''
      }
    },
    computed: {
      ...mapState(['options'])
    },
    methods: {
      backTop () {
        this.$nextTick(() => {
          window.scrollTo(0, 0)
        })
      },
      toggleContent (type) {
        if (this.showType === type) {
          this.showType = ''
        } else {
          this.showType = type
          setTimeout(() => {
            this.$nextTick(() => {
              window.scrollTo(0, 9999)
            })
          }, 20)
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .footer
    padding 0 4rem
    font-family 'NeutraText-BoldAlt'
    line-height 1.7
    .wrap
      height 90px
      align-items flex-end
      display flex
      .social
        .iconfont
          font-size 3rem
        .item
          cursor pointer
          + .item
            margin-left 4rem
    .icp
      font-size 1.6rem
      padding 1rem 0
    .copyright
      font-size 1.6rem
      padding 1rem 0
    .item-detail
      height 0
      overflow hidden
      visibility hidden
      transition-duration .3s
      opacity 0
      &.show
        height auto
        visibility visible
        opacity 1
      .line
        height 4px
        background-color #000
      .content
        padding 20px 0
        font-size inherit
        img.wechat
          width 200px
  .back-top
    margin 7rem auto 10rem
    text-align center
    cursor pointer

    .iconfont
      font-size 4rem
      display inline-block
      transform rotate(-90deg)

  @media screen and (max-width: 768px)
    .footer
      padding 0
      .item-detail
        padding 0 20px
        .line
          margin 20px 0
      .wrap
        flex-wrap wrap
        .social
          display flex
          justify-content center
          flex-basis 100%
        .copyright
          display flex
          flex-basis 100%
          align-items center
          justify-content center
      .item-detail
        .content
          img.wechat
            margin 0 auto

  @media screen and (min-width: 1921px)
    .footer
      .content
        width 50%
</style>
